import React from 'react';
import { Link } from 'react-router-dom';
import { AiFillGithub } from 'react-icons/ai';
import { FaFacebook, FaLinkedin } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';


const Header = () => {
    const menuItems = <>
        <li><Link to='/'>Home</Link></li>
        <li><Link to='/about'>About</Link></li>
        <li><a href='/#projects'>Projects</a></li>
        <li><Link to='/blog'>Blog</Link></li>
        <li><a href='/#contact'>Contact</a></li>
    </>
    return (
        <header className='sticky top-0 bg-base-200 z-[999]'>
            <nav className="navbar w-full px-0 lg:px-10">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex="0" className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex="0" className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                            {menuItems}
                        </ul>
                    </div>
                    <Link to='/' className="btn btn-ghost normal-case text-xl">My Portfolio</Link>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal p-0">
                        {menuItems}
                    </ul>
                </div>
                <div className="navbar-end text-xl">
                    <Link to='/' className='mx-2' ></Link>
                    <Link to='/' className='mx-2' ></Link>
                    <a href='https://github.com/mahabubulislam' target="_blank" rel='noreferrer' className='mx-2 p-0 lg:p-2 hover:text-teal-400'><AiFillGithub></AiFillGithub></a>
                    <a href='https://www.linkedin.com/in/mahabubulislam/' target="_blank" rel='noreferrer' className='mx-2 p-0 lg:p-2 hover:text-teal-400'><FaLinkedin></FaLinkedin></a>
                    <a href='https://www.facebook.com/mahabubulislam22/' target="_blank" rel='noreferrer' className='mx-2 p-0 lg:p-2 hover:text-teal-400'><FaFacebook></FaFacebook></a>
                </div>
            </nav>
        </header>
    );
};

export default Header;